module.exports = "/images/lojameste.png?d5274c4effc817b1053c97a2dae3d39c";